import { combineReducers } from '@reduxjs/toolkit';

import colorReducer from './slices/color';
import cookingApplianceReducer from './slices/cookingAppliance';
import cornerRadiiReducer from './slices/cornerRadii';
import customSideReducer from './slices/customSide';
import customerDataReducer from './slices/customerData';
import cutoutReducer from './slices/cutout';
import diagonalCornerReducer from './slices/diagonalCorner';
import dishwasherReducer from './slices/dishwasher';
import draggedApplianceReducer from './slices/draggedAppliance';
import drawingShapeReducer from './slices/drawingShape';
import edgeReducer from './slices/edge';
import estimateReducer from './slices/estimate';
import fabricReducer from './slices/fabric';
import layoutReducer from './slices/layout';
import materialReducer from './slices/material';
import optionalItemsReducer from './slices/optionalItems';
import plumbingReducer from './slices/plumbing/plumbing.slice';
import pricedProductsReducer from './slices/pricedProducts';
import refrigeratorReducer from './slices/refrigerator';
import routeReducer from './slices/route';
import shapeReducer from './slices/shape';
import sinkReducer from './slices/sink';
import sortAndFilterReducer from './slices/sortAndFilter';
import stepperReducer from './slices/stepper';
import storeReducer from './slices/store';
import tearOutReducer from './slices/tearOut';
import toolbarCanvasReducer from './slices/toolbarCanvas';
import undoStackReducer from './slices/undoStack';
import visitedStepsReducer from './slices/visitedSteps';
import zipcodeReducer from './slices/zipcode';

import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { staticContentService } from '~/api/local-api/localService';
import { productsApi } from '~/api/products-api/productsApiService';

const rootReducer = combineReducers({
  color: colorReducer,
  cookingAppliance: cookingApplianceReducer,
  cornerRadius: cornerRadiiReducer,
  cutout: cutoutReducer,
  customerData: customerDataReducer,
  customSide: customSideReducer,
  diagonalCorner: diagonalCornerReducer,
  dishwasher: dishwasherReducer,
  drawingShape: drawingShapeReducer,
  draggedAppliance: draggedApplianceReducer,
  edge: edgeReducer,
  fabric: fabricReducer,
  layout: layoutReducer,
  material: materialReducer,
  optionalItem: optionalItemsReducer,
  plumbing: plumbingReducer,
  pricedProducts: pricedProductsReducer,
  refrigerator: refrigeratorReducer,
  shape: shapeReducer,
  sink: sinkReducer,
  sortAndFilter: sortAndFilterReducer,
  stepper: stepperReducer,
  store: storeReducer,
  tearOut: tearOutReducer,
  toolbarCanvas: toolbarCanvasReducer,
  visitedSteps: visitedStepsReducer,
  zipcode: zipcodeReducer,
  [easyEstimatorApi.reducerPath]: easyEstimatorApi.reducer,
  [staticContentService.reducerPath]: staticContentService.reducer,
  [productsApi.reducerPath]: productsApi.reducer,
  estimate: estimateReducer,
  undoStack: undoStackReducer,
  route: routeReducer,
});

export default rootReducer;
